export default __webpack_public_path__ + "static/media/C2_24_x_30_Blanc.8393ce70.jpg";